document.addEventListener('DOMContentLoaded', () => {
  let isProcessing = false;

  document.addEventListener('click', (e) => {
    const checkoutBtn = e.target.closest('[data-checkout-btn]');
    if (!checkoutBtn) return;
    if (isProcessing) return;

    const container = checkoutBtn.closest('form[action="/cart/add"]')
                   || checkoutBtn.closest('.product-form__item--submit')
                   || checkoutBtn.closest('.product-form')
                   || document;

    const addBtn = container.querySelector('button[name="add"], [data-add-to-cart]');
    const originalFetch = window.fetch;

    isProcessing = true;
    checkoutBtn.classList.add('is-loading');

    document.querySelectorAll('[data-checkout-btn]').forEach(btn => {
      btn.setAttribute('disabled', 'true');
    });

    const resetState = () => {
      isProcessing = false;
      window.fetch = originalFetch;
      document.querySelectorAll('[data-checkout-btn]').forEach(btn => {
        btn.removeAttribute('disabled');
        btn.classList.remove('is-loading');
      });
    };

    // 全局抑制所有加购按钮的 loading 状态
    const observers = [];
    document.querySelectorAll('button[name="add"], [data-add-to-cart]').forEach(btn => {
      const loader = btn.querySelector('[data-loader]');
      if (!loader) return;

      const observer = new MutationObserver(() => {
        if (!loader.classList.contains('hide')) {
          loader.classList.add('hide');
        }
      });
      observer.observe(loader, { attributes: true, attributeFilter: ['class'] });
      observers.push(observer);
    });

    const disconnectAll = () => observers.forEach(ob => ob.disconnect());

    window.fetch = async (...args) => {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      const response = await originalFetch(...args);

      if (url.includes('/cart/add')) {
        disconnectAll();

        if (response.ok) {
          response.clone().json().then(() => {
            resetState();
            window.location.href = '/checkout';
          });
        } else {
          resetState();
          console.warn('[custom-checkout] 加购失败，状态码:', response.status);
        }
      }

      return response;
    };

    if (addBtn) {
      addBtn.click();
    } else {
      disconnectAll();
      resetState();
      console.warn('[custom-checkout] 未找到加购按钮');
    }
  });
});
